var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlidericon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150.936,
    height: 150.936,
    viewBox: "0 0 150.936 150.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.289,
    y1: -0.209,
    x2: 0.742,
    y2: 0.674,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c6bf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9204f1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_111",
    x: 0,
    y: 0,
    width: 150.936,
    height: 150.936,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 7,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a7cafd",
    floodOpacity: 0.729
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(-3975 -2919)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3975, 2919)",
    filter: "url(#Rectangle_111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111-2",
    "data-name": "Rectangle 111",
    width: 94,
    height: 94,
    rx: 30,
    transform: "translate(13 68.47) rotate(-45)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(4500.357 2614.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M-446.1,355.441a13.1,13.1,0,0,0-12.722,11.006,12.8,12.8,0,0,0,5.557,13.164,5.949,5.949,0,0,1,2.915,4.369c.1,1.1.033,2.213.042,3.32.01,1.205.532,1.785,1.733,1.8q2.952.043,5.9,0c1.19-.018,1.706-.6,1.752-1.81.053-1.4.038-2.8.227-4.182a4.469,4.469,0,0,1,1.9-2.892c.663-.507,1.346-.986,2.077-1.518l1.038,1.149c-.628.471-1.21.948-1.832,1.366a4.08,4.08,0,0,0-1.862,3.636c0,.861-.014,1.723,0,2.584a3.231,3.231,0,0,1-1.129,2.539,1.364,1.364,0,0,0-.4.858c-.045,1.155-.006,2.312-.022,3.469a3.183,3.183,0,0,1-3.453,3.446c-.886.007-1.772.014-2.657,0a3.117,3.117,0,0,1-3.281-3.3c-.01-1.23.009-2.461-.013-3.691a.9.9,0,0,0-.23-.635,3.506,3.506,0,0,1-1.369-3.174c.013-.46,0-.92,0-1.578-.381.369-.634.613-.886.86-.7.689-.874.7-1.7.131q-.79-.542-1.588-1.073c-.035-.024-.092-.015-.2-.03-.157.729-.331,1.459-.468,2.2a.92.92,0,0,1-1.063.867c-.885-.03-1.772-.03-2.657,0a.925.925,0,0,1-1.068-.862c-.14-.738-.309-1.47-.486-2.3-.681.465-1.3.857-1.885,1.294a.982.982,0,0,1-1.489-.113c-.643-.678-1.308-1.336-1.979-1.986a.935.935,0,0,1-.114-1.373c.436-.614.85-1.244,1.325-1.943-.858-.192-1.611-.376-2.371-.526a.91.91,0,0,1-.8-1.046c.013-.886.016-1.772,0-2.657a.951.951,0,0,1,.885-1.064c.722-.137,1.44-.3,2.3-.479-.441-.644-.835-1.217-1.226-1.792-.53-.779-.513-1,.131-1.653.623-.629,1.265-1.24,1.873-1.883a.954.954,0,0,1,1.43-.114c.593.43,1.207.83,1.809,1.24.76-1-.035-2.708,1.651-3.233a14.726,14.726,0,0,1,3.993-9.239,14.189,14.189,0,0,1,10.9-4.695,4.128,4.128,0,0,0,2.866-.97c1.593-1.283,1.621-1.248,2.832.38a14.509,14.509,0,0,0,1.076,1.4,1.048,1.048,0,0,0,.82.315.983.983,0,0,0,.571-.646c.191-.811.3-1.641.419-2.467.164-1.134.311-1.262,1.48-1.107,1.315.174,2.625.385,3.941.554a.8.8,0,0,1,.8,1c-.1.9-.261,1.8-.309,2.708a1.23,1.23,0,0,0,.352.98,1.275,1.275,0,0,0,1.034-.194c.685-.43,1.309-.957,1.963-1.437.718-.527,1.023-.5,1.546.177.854,1.112,1.679,2.245,2.525,3.362a.869.869,0,0,1-.191,1.392c-.709.53-1.441,1.034-2.106,1.615a1.171,1.171,0,0,0-.412.9c.057.251.474.525.777.594.884.2,1.788.318,2.688.442a.84.84,0,0,1,.806,1.079c-.19,1.411-.392,2.821-.591,4.232-.09.638-.421.984-1.1.889-.876-.122-1.747-.3-2.627-.355a1.291,1.291,0,0,0-.991.36,1.122,1.122,0,0,0,.131.974c.461.724,1.021,1.384,1.526,2.081.491.677.456,1-.187,1.493q-1.668,1.28-3.364,2.523c-.623.457-.957.4-1.433-.211-.512-.661-.971-1.365-1.52-1.993-.229-.262-.7-.583-.935-.5a1.365,1.365,0,0,0-.668.9c-.192.809-.249,1.649-.377,2.474-.119.761-.4.977-1.145.881-1.364-.176-2.728-.354-4.087-.559-.894-.135-1.063-.388-.95-1.3.106-.853.259-1.7.309-2.559.017-.294-.136-.767-.347-.864a1.22,1.22,0,0,0-1,.135c-.743.477-1.433,1.037-2.135,1.577a.862.862,0,0,1-1.387-.186c-.854-1.142-1.721-2.274-2.564-3.425-.439-.6-.369-.988.221-1.44.663-.509,1.373-.964,1.989-1.524a1.452,1.452,0,0,0,.457-1.03c-.015-.209-.5-.484-.816-.552-.838-.182-1.695-.284-2.548-.389a.861.861,0,0,1-.859-1.106c.2-1.461.38-2.924.606-4.38.1-.625.54-.829,1.148-.734.776.121,1.555.225,2.333.34.467.069.94.177,1.252-.334.328-.538-.086-.876-.346-1.242C-444.754,357.271-445.394,356.408-446.1,355.441Zm16.265,19.133,2.484-1.869-1.294-1.758a2.278,2.278,0,0,1-.192-2.689,2.267,2.267,0,0,1,2.386-1.119c.724.087,1.446.185,2.224.285l.433-3.087c-.715-.093-1.346-.169-1.975-.26a2.386,2.386,0,0,1-2.205-1.776,2.336,2.336,0,0,1,1.032-2.631c.548-.4,1.079-.818,1.642-1.246l-1.88-2.484c-.574.426-1.093.8-1.6,1.189a2.386,2.386,0,0,1-2.873.288,2.505,2.505,0,0,1-1.055-2.769c.1-.576.173-1.156.273-1.828l-3.082-.434c-.111.734-.209,1.363-.3,1.993a2.359,2.359,0,0,1-1.78,2.186,2.345,2.345,0,0,1-2.621-1.035c-.408-.541-.822-1.078-1.244-1.63l-2.473,1.865c.476.645.943,1.241,1.37,1.865a2.265,2.265,0,0,1,.087,2.633,2.27,2.27,0,0,1-2.408,1.061c-.7-.1-1.4-.181-2.163-.278l-.452,3.055c.612.1,1.183.213,1.76.276a2.462,2.462,0,0,1,2.454,1.856,2.4,2.4,0,0,1-1.155,2.652c-.508.369-1,.76-1.534,1.168l1.869,2.488c.632-.473,1.191-.912,1.772-1.32a2.423,2.423,0,0,1,2.764-.133,2.5,2.5,0,0,1,1.012,2.585c-.113.643-.181,1.295-.275,1.992l3.075.413c.109-.772.2-1.426.295-2.078a2.338,2.338,0,0,1,1.862-2.123,2.335,2.335,0,0,1,2.54,1.082C-430.665,373.485-430.264,374.007-429.835,374.574Zm-34.706,10.355c.559-.374,1.092-.763,1.657-1.1a1.537,1.537,0,0,1,2.353.907,6.471,6.471,0,0,1,.3,1.362c.047.578.313.718.856.7,1.144-.032,1.146,0,1.387-1.137.051-.24.082-.485.139-.724A1.579,1.579,0,0,1-455.3,383.9c.512.328,1.007.684,1.646,1.12a10.914,10.914,0,0,1,1.142-1.281.684.684,0,0,0,.1-1.119c-.785-.817-1.63-1.576-2.461-2.367-1.923,2.4-3.78,3.1-5.893,2.313a4.669,4.669,0,0,1-3.111-4.692c.094-2.151,1.551-3.748,4.076-4.444-.149-.662-.3-1.327-.451-1.99-.015-.063-.087-.112-.136-.172-.713,1.637-1.54,1.86-3.035.832-.375-.258-.759-.5-1.086-.719l-1.437,1.4c.373.553.773,1.084,1.107,1.653a1.522,1.522,0,0,1-.938,2.333c-.633.18-1.284.3-1.981.46v1.851c.64.132,1.19.244,1.739.36a1.586,1.586,0,0,1,1.084,2.573c-.325.512-.683,1-1.011,1.483Zm5.779-3.687a2.812,2.812,0,0,0,2.3-1.6.864.864,0,0,0-.054-.744c-.779-1.183-1.585-2.35-2.424-3.49a.957.957,0,0,0-.751-.348,3.119,3.119,0,0,0-2.582,3.4C-462.132,380-460.824,381.19-458.761,381.242Zm16.228,12.632h-6.18c-.2,1.586.4,2.272,1.921,2.276q1.141,0,2.281,0C-442.936,396.148-442.357,395.493-442.533,393.874Zm0-1.657v-1.5h-6.193v1.5Z",
    transform: "translate(0 -1.401)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M-371.146,433.978h-1.547a16.486,16.486,0,0,0-.612-2.064,5.248,5.248,0,0,0-2.928-2.652,10.709,10.709,0,0,1-6.571-8.133,10.862,10.862,0,0,1,4.926-11.249l.81,1.239c-.171.152-.3.289-.452.4a9.366,9.366,0,0,0,1.641,16.17,7.082,7.082,0,0,1,4.229,4.14C-371.427,432.488-371.326,433.19-371.146,433.978Z",
    transform: "translate(-73.605 -51.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M-455.08,379.268l.913-1.275,5.485,3.916-.911,1.279Z",
    transform: "translate(-12.169 -24.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M-406.434,355.362l-1.514.4-1.6-6.252,1.509-.411Z",
    transform: "translate(-50.976)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M-456.643,431.813l-6.172,1.544c-.044-.053-.109-.1-.128-.16-.414-1.318-.414-1.322.922-1.659,1.639-.413,3.28-.817,4.984-1.241Z",
    transform: "translate(-5.26 -69.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M-215.434,574.772l4.68,3.9-1,1.216-4.7-3.921Z",
    transform: "translate(-215.568 -192.354)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M-237.759,595.039h-1.458v-5.414h1.458Z",
    transform: "translate(-196.163 -205.015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M-207.634,548.762c-.017-.142-.041-.258-.043-.375-.005-.341,0-.682,0-1.077h5.472v1.452Z",
    transform: "translate(-223.043 -168.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M-312.1,584.323V586.6h-1.469v-2.281Z",
    transform: "translate(-132.792 -200.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M-283.408,406.021A6.223,6.223,0,0,1-277.1,399.8a6.264,6.264,0,0,1,6.238,6.313,6.326,6.326,0,0,1-6.288,6.218A6.29,6.29,0,0,1-283.408,406.021Zm10.952,0a4.762,4.762,0,0,0-4.688-4.7,4.793,4.793,0,0,0-4.707,4.7,4.765,4.765,0,0,0,4.741,4.727A4.736,4.736,0,0,0-272.456,406.025Z",
    transform: "translate(-158.496 -43.211)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlidericon3);
export default __webpack_public_path__ + "static/media/slidericon3.8fb94f2eb04ddc0febb378282044909f.svg";
export { ForwardRef as ReactComponent };